import {useMemo, useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios} from "../../lib/axios.js";
import {omit} from "../../../__snowpack__/pkg/lodash.js";
import {handleError} from "../../lib/errorHandler.js";
export const VARIATIONKEY = "gineeSystemAutoCreate";
export const useExternalShopId = () => {
  const [externalShopId, setExternalShopId] = useState();
  const resetExternalShopId = () => {
    setExternalShopId("");
  };
  return {
    externalShopId,
    setExternalShopId,
    resetExternalShopId
  };
};
export const useExternalShopIdModel = createModel(useExternalShopId);
export const useExternalWareId = () => {
  const [externalWareId, setExternalWareId] = useState();
  const resetExternalWareId = () => {
    setExternalWareId("");
  };
  const fetchExternalWare = async (params) => {
    const {data} = await axios.post("/saas/shop/get-shop-warehouse-by-channel-shop", params);
    if (data && data[0]) {
      setExternalWareId(data[0]?.externalWareId);
    }
  };
  return {
    externalWareId,
    setExternalWareId,
    resetExternalWareId,
    fetchExternalWare
  };
};
export const useExternalWareIdModel = createModel(useExternalWareId);
export const useShopCountry = () => {
  const [shopCountry, setShopCountry] = useState();
  const [shopId, setShopId] = useState();
  const [currencyCode, setCurrencyCode] = useState();
  const [supportMultiWarehouse, setSupportMultiWarehouse] = useState();
  return {
    shopCountry,
    setShopCountry,
    setShopId,
    shopId,
    setCurrencyCode,
    currencyCode,
    supportMultiWarehouse,
    setSupportMultiWarehouse
  };
};
export const useShopCountryModel = createModel(useShopCountry);
export const useCatrgoryInfo = () => {
  const [catrgoryInfo, setCatrgoryInfo] = useState();
  return {
    catrgoryInfo,
    setCatrgoryInfo
  };
};
export const useCatrgoryInfoModel = createModel(useCatrgoryInfo);
export const useCategoryRuleChannel = () => {
  const [data, setData] = useState({
    categoryId: "",
    isSizeChartMandatory: false,
    tiktokSupportSizeChart: false,
    tiktokSupportCod: false,
    tiktokProductCertifications: []
  });
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post("/saas/shop/get-categoryRule-by-channel", params);
      if (!data2) {
        setData({
          categoryId: "",
          tiktokSupportSizeChart: false,
          isSizeChartMandatory: false,
          tiktokSupportCod: false,
          tiktokProductCertifications: []
        });
      } else {
        const {
          categoryId,
          isSizeChartMandatory,
          tiktokSupportSizeChart,
          tiktokSupportCod,
          tiktokProductCertifications = []
        } = data2;
        setData({
          isSizeChartMandatory,
          categoryId,
          tiktokSupportSizeChart,
          tiktokSupportCod,
          tiktokProductCertifications
        });
      }
      return data2;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const reset = () => {
    setData({
      categoryId: "",
      tiktokSupportSizeChart: false,
      isSizeChartMandatory: false,
      tiktokSupportCod: false,
      tiktokProductCertifications: []
    });
  };
  return {
    resetCategoryRuleChannel: reset,
    categoryRuleChannelLoading: loading,
    categoryRuleChannel: data,
    fetchCategoryRuleChannel: fetchData
  };
};
export const useCategoryRuleChannelModel = createModel(useCategoryRuleChannel);
const useVariationOptions = () => {
  const defaultVariation = {variationTypeData: "", options: []};
  const defaultData = [
    {
      options: ["undefined"],
      variationTypeData: {
        key: "gineeSystemAutoCreate-undefined",
        label: "undefined",
        value: "gineeSystemAutoCreate-undefined"
      }
    }
  ];
  const [data, setData] = useState(defaultData);
  const handleSetVariationOptions = (values) => {
    if (values[0]?.variationTypeData === "") {
      setData(defaultData);
    } else {
      setData(values);
    }
  };
  return {
    defaultVariation,
    defaultData,
    variationOptions: data,
    handleSetVariationOptions
  };
};
export const useVariationOptionsModel = createModel(useVariationOptions);
export const useCategoryAttributes = () => {
  const [data, setData] = useState([]);
  const [firstData, setFirstData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (param, isFirst) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/shop/get-categoryAttributes-by-channel`, param);
      setData(data2);
      if (isFirst) {
        setFirstData(data2);
      }
      return data2;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const mandatoryData = useMemo(() => {
    return data.filter((_) => _.mandatory);
  }, [data]);
  const optionalData = useMemo(() => {
    return data.filter((_) => !_.mandatory);
  }, [data]);
  const salesAttributeData = useMemo(() => {
    return data.filter((_) => _.scope == "SALES_ATTRIBUTE").map((item) => {
      return {
        ...item,
        mandatory: item.mandatory,
        label: item.attributeName,
        value: item.attributeId
      };
    });
  }, [data]);
  const onlyEditSalesAttributeData = useMemo(() => {
    return data.filter((_) => _.scope == "SALES_ATTRIBUTE").map((item) => {
      return {
        ...item,
        label: item.attributeName,
        value: item.attributeId
      };
    });
  }, [firstData]);
  const onlyEditAttributeData = useMemo(() => {
    return data.filter((_) => _.scope == "PRODUCT").map((item) => {
      return {
        ...item,
        label: item.attributeName,
        value: item.attributeId
      };
    });
  }, [data]);
  const resetData = () => {
    setData([]);
  };
  return {
    resetData,
    categoryAttributeLoading: loading,
    categoryAttributes: data,
    salesAttributeData,
    onlyEditSalesAttributeData,
    mandatoryCategoryAttributes: mandatoryData,
    optionalCategoryAttributes: optionalData,
    onlyEditAttributeData,
    fetchCategoryAttributes: fetchData
  };
};
export const useCategoryAttributesModel = createModel(useCategoryAttributes);
export const useTikTokProductInfo = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (productId) => {
    setLoading(true);
    try {
      let param = {
        productId,
        channelId: "TIKTOK_ID"
      };
      let {data: data2} = await axios.post(`/saas/product/get-product`, {
        ...param
      });
      setData({...data2, shopIds: [data2?.shopId]});
      return {
        productInfo: data2.data
      };
    } catch (error) {
      handleError(error);
      return {
        productInfo: {}
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productInfoLoading: loading,
    productInfo: data,
    fetchProductInfo: fetchData
  };
};
export const useTikTokProductInfoModel = createModel(useTikTokProductInfo);
export const useBrands = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const fetchData = async (params, isUpdate) => {
    if (isUpdate) {
      setUpdateLoading(true);
    } else {
      setLoading(true);
    }
    try {
      const {data: data2} = await axios.get(`/saas/product-brand/channels/get-brands-by-channel`, {
        params: omit(params, "appendBrands")
      });
      let newData = data2;
      if (!params.prefix) {
        newData = [
          {
            label: "0",
            value: "NoBrand"
          },
          ...data2.filter((uData) => {
            return uData.label != "0";
          })
        ];
      }
      setData([...params.appendBrands || [], ...newData].reduce((acc, cur) => {
        if (!acc.find((_) => _.label === cur.label)) {
          acc.push(cur);
        }
        return acc;
      }, []));
      return newData;
    } catch (error) {
      handleError(error);
    } finally {
      if (isUpdate) {
        setUpdateLoading(false);
      } else {
        setLoading(false);
      }
    }
  };
  return {
    brandsLoading: loading,
    updateBrandsLoading: updateLoading,
    brands: data,
    fetchBrands: fetchData,
    setBrands: setData
  };
};
export const useBrandsModel = createModel(useBrands);
export default {};
export const PRODUCTNAME_MIN_NUMBER = 25;
export const PRODUCTNAME_MAX_NUMBER = 255;
